import React from "react";
import "./ServicesSection.css";

import windImg from "../../assets/wind.png";
import solarImg from "../../assets/solar.png";
import maintenanceImg from "../../assets/maintenance.png";

export default function ServicesSection() {
  const services = [
    {
      title: "Wind",
      category: "Speciality",
      img: windImg,
      list: [
        "Turnkey project",
        "Land Acquisition",
        "Grid Integration",
        "HT / LT Infra development",
        "Procurement",
        "Engineering",
        "Installation",
        "Main component replacement using WTG-specific technology",
        "Commissioning & Support",
        "Operation & Maintenance",
      ],
      reverse: false,
    },
    {
      title: "Solar",
      category: "Speciality",
      img: solarImg,
      list: [
        "Turnkey project",
        "Land Acquisition",
        "Grid Integration",
        "HT / LT Infra development",
        "Engineering",
        "Procurement",
        "Installation",
        "Commissioning",
        "Monitoring",
      ],
      reverse: true,
    },
    {
      title: "Operation & Maintenance of Solar Energy",
      category: "Speciality",
      img: maintenanceImg,
      list: [
        "Preventive and corrective maintenance",
        "Performance monitoring, reporting, improvement",
        "Infrastructure tracking",
        "SCADA – Remote & onsite performance monitoring",
      ],
      reverse: false,
    },
  ];

  return (
    <section className="ss-section">
      <div className="ss-container">
        {services.map((item, index) => (
          <div
            className={`ss-row ${item.reverse ? "ss-reverse" : ""}`}
            key={index}
          >
            {/* LEFT TEXT */}
            <div className="ss-textbox">
              <p className="ss-category"><i className="fa fa-cog" style={{ marginRight: '5px' }}></i>{item.category}</p>
              <h2 className="ss-title">{item.title}</h2>

              <ul className="ss-list">
                {item.list.map((li, i) => (
                  <li key={i}>{li}</li>
                ))}
              </ul>
            </div>

            {/* RIGHT IMAGE */}
            <div className="ss-imagebox">
              <img src={item.img} alt={item.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
